// components/ui/tourGeometry.ts
// The guided tours (Slides, Daimon) highlight a real control: its box as the user actually sees it.

export type TourBox = { left: number; top: number; width: number; height: number };

/** The visible part of an element: clipped to the viewport and to every scroll container (a
 *  collapsed panel still holds full-sized children), null when hidden or too small to point at. */
export const visibleBox = (element: HTMLElement): TourBox | null => {
  const rect = element.getBoundingClientRect();
  let left = Math.max(0, rect.left), top = Math.max(0, rect.top);
  let right = Math.min(window.innerWidth, rect.right), bottom = Math.min(window.innerHeight, rect.bottom);
  for (let parent: HTMLElement | null = element; parent; parent = parent.parentElement) {
    const style = getComputedStyle(parent);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return null;
    const bounds = parent.getBoundingClientRect();
    if (style.overflowX !== 'visible') { left = Math.max(left, bounds.left); right = Math.min(right, bounds.right); }
    if (style.overflowY !== 'visible') { top = Math.max(top, bounds.top); bottom = Math.min(bottom, bounds.bottom); }
  }
  return right - left > 12 && bottom - top > 12 ? { left, top, width: right - left, height: bottom - top } : null;
};
